import { RouterModule, Routes } from '@angular/router';
import { AdminLayoutComponent } from './containers/admin-layout/admin-layout';
// import { UsersComponent } from '../users/users.component';
import { AuthGuard } from './guards/auth.guard';
import { DashboardPageComponent } from './containers/dashboard-page/dashboard-page';
import { LoginPageComponent } from './containers/login-page/login-page';
import { MainPageComponent } from './containers/main-page/main-page';
import { UtilPageComponent } from './containers/util-page/util-page';
import { MainMenuPageComponent } from './containers/main-menu-page/main-menu-page';
import { PermissionsPageComponent } from './containers/permissions-page/permissions-page';
import { AuthSuperAdminGuard } from './guards/auth-super-admin.guard';
import { PrintingPageComponent } from './containers/printing-page/printing-page';
import { PrintingOutputPageComponent } from './containers/printing-output-page/printing-output-page';
import { ExportXmlPageComponent } from './containers/export-xml-page/export-xml-page';
import { ExportDocxPageComponent } from './containers/export-docx-page/export-docx-page';


const routes: Routes = [
  // {
  //   path: 'admin',
  //   component: AdminLayoutComponent,
  //   canActivate: [AuthGuard],
  //   children: [
  //     { path: '', redirectTo: '/admin/main', pathMatch: 'full' },
  //     { path: 'main', component: MainPageComponent },
      { path: 'dashboard', component: DashboardPageComponent },
    // ]
  // },
  {
    path: 'login',
    component: LoginPageComponent,
  },
  {
    path: 'admin/main',
    component: MainPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/util',
    component: UtilPageComponent,
    canActivate: [AuthSuperAdminGuard],
  },
  {
    path: 'admin/main-menu',
    component: MainMenuPageComponent,
    canActivate: [AuthSuperAdminGuard],
  },
  {
    path: 'admin/permissions',
    component: PermissionsPageComponent,
    canActivate: [AuthSuperAdminGuard],
  },
  {
    path: 'admin/printing',
    component: PrintingPageComponent,
    canActivate: [AuthSuperAdminGuard],
  },
  {
    path: 'admin/printing/:letter',
    component: PrintingOutputPageComponent,
    canActivate: [AuthSuperAdminGuard],
  },
  {
    path: 'admin/export-xml',
    component: ExportXmlPageComponent,
    canActivate: [AuthSuperAdminGuard],
  },
  {
    path: 'admin/export-docx',
    component: ExportDocxPageComponent,
    canActivate: [AuthSuperAdminGuard],
  },
];


export const AdminAreaRoutingModule = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/admin-area-routing.module.ts